/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Musha 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Akabare": ["Akabare", "Binunga", "Budahigwa", "Duha", "Gashikiri", "Rugabano", "Rukombe"],
  "Budahanda": ["Karambo", "Nyantoki", "Rwabiyange"],
  "Kagarama": ["Kagarama", "Kiruhura", "Muhogoto", "Nyagacyamo", "Nyamigano"],
  "Musha": ["Gatika", "Kadasumbwa", "Karifuru", "Nyakiriba", "Rugarama"],
  "Nyabisindu": ["Agashuhe", "Busanza", "Bwiza", "Nyabisindu", "Rujumbura", "Rwamivu", "Umunini"],
  "Nyakabanda": ["Bitsibo", "Ruhita", "Rutoma"]
};